import axios from 'axios'
import { message } from 'antd'

const client = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器 - 附带 token
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 统一错误处理
client.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const { response } = error

    if (response?.status === 401) {
      // 未授权，跳转登录
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = `${import.meta.env.BASE_URL}login`
      message.error('登录已过期，请重新登录')
    } else if (response?.status === 403) {
      message.error('没有权限执行此操作')
    } else if (response?.status === 404) {
      message.error('资源不存在')
    } else {
      const errorMsg = response?.data?.error || '请求失败'
      message.error(errorMsg)
    }

    return Promise.reject(error)
  }
)

export default client
